import { connect } from 'react-redux';

import { getPartnerLoyaltyInfo } from '../../../../store/partnerLoyalty/selectors';
import { setPartnerLoyaltyProgramCardNumber } from '../../../../store/partnerLoyalty/slice';

import PartnerLoyalty from './PartnerLoyalty';

const mapStateToProps = (state) => ({
  partnerLoyaltyInfo: getPartnerLoyaltyInfo(state),
});

const mapDispatchToProps = (dispatch) => ({
  setCardNumber: (cardNumber: string | null) => {
    dispatch(setPartnerLoyaltyProgramCardNumber(cardNumber));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PartnerLoyalty);
